import AppState from './statelogic'
import Routes from './routes'
const SocketState = new AppState(Routes)
export default SocketState